var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper"},[_c('apexchart',{attrs:{"type":'pie',"series":_vm.series,"options":_vm.chartOptions,"height":_vm.chartHeight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }